import { render, staticRenderFns } from "./CommonRegisterFooter.vue?vue&type=template&id=4a12e248&"
import script from "./CommonRegisterFooter.vue?vue&type=script&lang=js&"
export * from "./CommonRegisterFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports